<ng-container *ngIf="service.enabled">
  <!-- FAB (visible quand le panel est fermé ; par défaut en env 'development',
       pilotable via le flag env DEV_TOOLS_FAB et __DEV_TOOLS__.show()/.hide()) -->
  <button
    *ngIf="service.showFab() && !service.isOpen()"
    type="button"
    (click)="openFab()"
    class="devtools-fab"
    title="Ouvrir DevTools (Ctrl+Shift+D)"
    aria-label="Ouvrir DevTools"
  >
    <i class="ph ph-bug"></i>
    <span class="devtools-fab__pulse" aria-hidden="true"></span>
  </button>

  <!-- Panel flottant -->
  <section
    *ngIf="service.isOpen()"
    class="devtools-panel"
    [class.devtools-panel--minimized]="service.minimized()"
    [style.left.px]="service.position().x"
    [style.top.px]="service.position().y"
    [style.width.px]="service.position().w"
    [style.height.px]="service.minimized() ? 40 : service.position().h"
    role="dialog"
    aria-label="DevTools Panel"
  >
    <!-- Title bar -->
    <header class="devtools-titlebar" (mousedown)="startDrag($event)">
      <div class="devtools-titlebar__left">
        <span class="devtools-titlebar__emoji" aria-hidden="true">🛠</span>
        <span class="devtools-titlebar__title">DevTools — Démarches</span>
        <span class="devtools-titlebar__count" title="Events capturés">
          {{ eventCount() }} ev
        </span>
      </div>
      <div class="devtools-titlebar__actions" (mousedown)="$event.stopPropagation()">
        <button
          type="button"
          class="devtools-btn"
          (click)="clearEvents()"
          title="Vider les events"
          aria-label="Vider les events"
        >
          <i class="ph ph-trash"></i>
        </button>
        <button
          type="button"
          class="devtools-btn"
          (click)="toggleMinimize()"
          [title]="service.minimized() ? 'Agrandir' : 'Réduire'"
          [attr.aria-label]="service.minimized() ? 'Agrandir' : 'Réduire'"
        >
          <i class="ph" [class.ph-arrows-out]="service.minimized()" [class.ph-minus]="!service.minimized()"></i>
        </button>
        <button
          type="button"
          class="devtools-btn devtools-btn--danger"
          (click)="close()"
          title="Fermer (Echap)"
          aria-label="Fermer"
        >
          <i class="ph ph-x"></i>
        </button>
      </div>
    </header>

    <ng-container *ngIf="!service.minimized()">
      <!-- Tabs -->
      <nav class="devtools-tabs" role="tablist">
        <button
          *ngFor="let t of service.tabs(); trackBy: trackTab"
          type="button"
          role="tab"
          [attr.aria-selected]="service.activeTabId() === t.id"
          class="devtools-tab"
          [class.devtools-tab--active]="service.activeTabId() === t.id"
          (click)="selectTab(t.id)"
        >
          <i *ngIf="t.icon" [class]="t.icon"></i>
          <span>{{ t.label }}</span>
          <span *ngIf="badge(t.id) as b" class="devtools-tab__badge">{{ b }}</span>
        </button>
        <div *ngIf="service.tabs().length === 0" class="devtools-tabs__empty">
          Aucun onglet enregistré.
        </div>
      </nav>

      <!-- Content -->
      <div class="devtools-content">
        <ng-container *ngIf="activeComponent() as cmp; else noTab">
          <ng-container *ngComponentOutlet="cmp"></ng-container>
        </ng-container>
        <ng-template #noTab>
          <div class="devtools-empty">
            <p>Aucun onglet actif.</p>
            <p class="devtools-empty__hint">
              Enregistre un composant via
              <code>DEV_TOOLS_TAB_COMPONENTS</code> (multi-provide).
            </p>
          </div>
        </ng-template>
      </div>

      <!-- Resize handle (bottom-right) -->
      <div
        class="devtools-resize"
        (mousedown)="startResize($event)"
        aria-hidden="true"
      ></div>
    </ng-container>
  </section>
</ng-container>
